import definition from './definition.json';
import presets from './Presets';

export default { definition, presets };
